import { render, staticRenderFns } from "./SideFilter.vue?vue&type=template&id=07604c92"
import script from "./SideFilter.vue?vue&type=script&lang=js"
export * from "./SideFilter.vue?vue&type=script&lang=js"
import style0 from "./SideFilter.vue?vue&type=style&index=0&id=07604c92&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports